import axios from 'axios';
import workareaHelper from '../helpers/services/workarea';
import servicesCommon from '../helpers/services/common';
import utilities from '../helpers/utility';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  async searchOrder(params) {
    const lookupPayload = {
      order_query: {
        _id: params.orderNumber ? params.orderNumber.toUpperCase() : '',
        email: params.email || '',
        'total_price.cents': (params.totalPrice ? params.totalPrice / 100 : ''),
        team_number: params.teamNumber || '',
        ip_address: params.ipAddress || '',
      },
      payment_query: {
        'credit_card.display_number': (params.ccLastFour ? `XXXX-XXXX-XXXX-${params.ccLastFour}` : ''),
      },
    };

    Object.keys(lookupPayload.order_query).forEach((k) => {
      if (lookupPayload.order_query[k] === '') { delete lookupPayload.order_query[k]; }
    });
    Object.keys(lookupPayload.payment_query).forEach((k) => {
      if (lookupPayload.payment_query[k] === '') { delete lookupPayload.payment_query[k]; }
    });

    if (utilities.deepEntries(lookupPayload).map(i => i[1]).filter(i => typeof i === 'string' && i != '').length == 0) {
      return [];
    }

    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/workarea/order/search`,
      data: lookupPayload,
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      console.error(error);
      return [];
    });
  },
  getSalesOrder(salesOrderNumber) {
    let salesOrder = {
      exists: false,
    };

    return axios
      .get(`${BASE_API}/workarea/order/${salesOrderNumber}`)
      .then(async (response) => {
        const data = response.data;
        console.log('raw wa response', data);

        if (!Object.prototype.hasOwnProperty.call(data, 'problem')) {
          const orderDate = new Date(data.order.placed_at);
          let shipping = {};
          if (data && data.shippings && data.shippings[0]) {
            shipping = data.shippings[0];
          }

          salesOrder = {
            id: data.order._id,
            email: data.order.email,
            user_id: data.order.user_id,
            program: data.order.program,
            team_number: data.order.team_number,
            totalPrice: data.order.total_price,
            shippingTotal: data.order.shipping_total,
            subtotalPrice: data.order.subtotal_price,
            taxTotal: data.order.tax_total,
            totalValue: data.order.total_value,
            orderedOn: orderDate.toLocaleString('en-US'),
            quote: !!data.order.quote,
            placed: !!data.order.placed_at,
            canceled: !!data.order.canceled_at,
            daysSince: servicesCommon.dateDiff(new Date(), orderDate),
            rawSalesOrderItems: data.order.items.map( i => { delete i.created_at; delete i.updated_at; return i; }).reverse(),
            items: workareaHelper.getSalesOrderItems(data.order),
            paymentMethods: Object.entries(data.payment).map((payment) => {
              if (payment[1] && payment[1].amount) {
                const obj = {};
                obj[payment[0]] = payment[1];
                return workareaHelper.getPaymentMethod(
                  obj,
                  data.order,
                );
              }
            }).filter(i => i),
            gift_cards: workareaHelper.getGiftCards(data.payment),
            paymentTransactions: data.payment_transactions,
            paymentStatus: data.payment_status,
            billTo: workareaHelper.getFormattedAddress(data.payment),
            shipTo: workareaHelper.getFormattedAddress(shipping),
            phone_number: data.payment.address ? data.payment.address.phone_number : '',
            orderNotes: shipping.instructions,
            imported: data.order.imported,
            need_issued: data.order.need_issued,
            created_at: data.order.created_at,
            updated_at: data.order.updated_at,
            shipping_updated_at: shipping.updated_at,
            orderPrivateNotes: data.order_private_notes,
            customerPrivateNotes: data.customer_private_notes,
            taxExemptFormId: data.order.tax_exempt_form_id,
            taxRecalcNeeded: false,
            exists: true,
          };

          if (salesOrder.taxExemptFormId) {
            let tef = await this.getTaxExemptForm(salesOrder.taxExemptFormId)
            salesOrder.taxExemptForm = tef.data.tax_exempt_form
          }

          if (shipping._id) {
            salesOrder.shipping = {
              total: data.order.shipping_total.cents / 100,
              tax: shipping.tax_total.cents / 100,
              id: shipping._id,
              price_adjustments: shipping.price_adjustments,
            };
          }
        }
        return salesOrder;
      })
      .catch((error) => {
        console.error('err', error);
        return {
          exists: false,
        };
      });
  },

  updateSalesOrder(salesOrderNumber, order) {
    if (!order.exists) return {};
    if (order.shipping && order.shipping.price_adjustments) {
      order.shipping.price_adjustments.forEach((pa) => {
        if (pa.price === 'shipping') {
          pa.description = order.shipTo.shippingPriority;
        }
      });
    }

    const data = {
      order: {
        // items: workareaHelper.cleanSalesOrderItems(order),
        email: order.email,
        user_id: (order.user_id == '' ? null : order.user_id),
        checkout_by_id: (order.user_id == '' ? null : order.user_id),
        program: order.program,
        team_number: order.team_number,
        imported: order.imported,
        need_issued: order.need_issued,
        items: order.rawSalesOrderItems.map( i => {
          i.product_attributes.description = i.product_attributes.name;
          delete i.product_attributes.created_at;
          delete i.product_attributes.updated_at;
          if (i.product_attributes.images) {
            i.product_attributes.images = i.product_attributes.images.map( e => {
              delete e.updated_at;
              delete e.created_at;
              return e;
            });
          }
          delete i.product_attributes.product_documents;
          i.price_adjustments.forEach( pa => {
            if (pa.data.original_price) {
              pa.data.original_price = Number(pa.data.original_price);
            }
          })
          return i;
        }).reverse(),
        tax_exempt_form_id: order.taxExemptFormId,
        total_price: {
          cents: order.totalPrice.cents,
        },
        total_value: {
          cents: order.rawSalesOrderItems.map( i => i.total_price.cents ).reduce( (a,v) => a + v, 0),
        },
        subtotal_price: {
          cents: order.rawSalesOrderItems.map( i => i.total_price.cents ).reduce( (a,v) => a + v, 0),
        },
        tax_total: {
          cents: order.taxTotal.cents
        },
        shipping_total: {
          cents: (order.shipping ? order.shipping.total * 100 : 0),
        },
      },
      payment: {
        address: {
          first_name: order.billTo.firstName,
          last_name: order.billTo.lastName,
          company: order.billTo.company,
          street: order.billTo.street1,
          street_2: order.billTo.street2,
          city: order.billTo.city,
          region: order.billTo.region,
          country: order.billTo.country,
          postal_code: order.billTo.postal_code,
          phone_number: order.billTo.phone_number,
          verified: true,
          skip_reset_verified: true,
          residential: order.billTo.residential,
        },
      },
    };

    if (order.shipping) {
      data.shippings = {
        0: {
          id: order.shipping.id,
          instructions: order.orderNotes,
          address: {
            first_name: order.shipTo.firstName,
            last_name: order.shipTo.lastName,
            company: order.shipTo.company,
            street: order.shipTo.street1,
            street_2: order.shipTo.street2,
            city: order.shipTo.city,
            region: order.shipTo.region,
            country: order.shipTo.country,
            postal_code: order.shipTo.postal_code,
            phone_number: order.shipTo.phone_number,
            verified: true,
            skip_reset_verified: true,
            residential: order.shipTo.residential,
          },
          shipping_service: {
            carrier: order.shipTo.carrier,
            name: order.shipTo.shippingPriority,
            service_code: order.shipTo.shippingCode,
          },
          tax_total: {
            cents: order.taxTotal.cents
          },
          price_adjustments: order.shipping.price_adjustments,
          shipping_total: (order.shipping ? order.shipping.total : 0),
        },
      };
    }

    order.paymentMethods.forEach((pm) => {
      if(pm.originalTerms != "gift_card" && pm.originalTerms != "pdv" && pm.originalTerms != "store_credit") {
        if(pm.originalTerms == 'purchase_order') {
          data.order.po_number = pm.poNumber;
        }
        if (pm.originalTerms != pm.paymentTerms) {
          if (pm.originalTerms != 'unknown') {
            data.payment[pm.originalTerms] = null;
          }
        }
        if(pm.paymentObject) {
          pm.paymentObject.amount.cents = pm.amount * 100;
          data.payment[pm.paymentTerms] = pm.paymentObject;
        }
      }
    });

    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/workarea/${salesOrderNumber}/update`,
      data: order,
    });
  },

  cancelSalesOrder(soNum) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/workarea/${soNum}/cancel`,
    });
  },

  checkCustomerID(email) {
    return axios.get(`${BASE_API}/workarea/customer/${email}`);
  },

  findWorkareaCustomer(email) {
    return axios
      .get(`${BASE_API}/workarea/customer/${email}`)
      .then(response => response)
      .catch((error) => {
        console.error('err', error);
        return {
          exists: false,
        };
      });
  },

  findWorkareaUser(id) {
    return axios
      .get(`${BASE_API}/workarea/user/${id}`)
      .then(response => response)
      .catch((error) => {
        console.error('err', error);
        return {
          exists: false,
        };
      });
  },

  updateWorkareaUser(id, data) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/workarea/customer/${id}`,
      data: data,
    });
  },

  getUserTaxExemptForms(id) {
    return axios
    .get(`${BASE_API}/workarea/tax_exempt_forms/user/${id}`)
    .then(response => response)
    .catch((error) => {
      console.error('err', error);
      return {
        exists: false,
      };
    });
  },

  async getTaxExemptForm(id) {
    try {
      const response = await axios.get(`${BASE_API}/workarea/tax_exempt_forms/${id}`);
      return response;
    } catch (error) {
      console.error('err', error);
      return {};
    }
  },

  getShippingServices() {
    return axios.get(`${BASE_API}/workarea/shipping_services`);
  },

  getProduct(sku) {
    return axios
      .get(`${BASE_API}/workarea/products/${sku}`)
      .then(response => JSON.parse(response.data))
      .catch((error) => {
        console.error('err', error);
        return {
          exists: false,
        };
      });
  },

  getTaxRates() {
    return axios
      .get(`${BASE_API}/workarea/tax_rates`)
      .then(response => JSON.parse(response.data))
      .catch((error) => {
        console.error('err', error);
        return {
          rates: []
        };
      });
  },

  getPurchasedGiftCards(num) {
    return axios
      .get(`${BASE_API}/workarea/order/${num}/gift_cards`)
      .then(response => response.data)
      .catch((error) => {
        console.error('err', error);
        return {
          exists: false,
        };
      });
  },

  getReturn(id) {
    return axios
      .get(`${BASE_API}/workarea/returns/${id}`)
      .then(response => {
        let r = response.data
        if (typeof(r.return) !== 'undefined') {
          r.return.exists = true;
        } else {
          r =  { return: { exists: false } }
        }
        return r;
      }).catch((error) => {
        console.error(error);
        return undefined;
      })
  },
};



// WEBPACK FOOTER //
// /src/services/workarea.js